/**
 * The line between two pieces of evidence that says what Grow did between
 * them: sparkles, a short sentence ("Grow reads every packet"), a down arrow.
 * The sparkles and arrow are decoration; the sentence is read out.
 *
 * Used by: sections/SeedPacketsV2.tsx and sections/Scrapbook.tsx.
 *
 * @module FlowArrow
 */

import React from 'react';
import { ArrowDown, Sparkles } from 'lucide-react';

/** What the line says. */
interface FlowArrowProps {
  /** The sentence between the sparkles and the arrow. */
  children: React.ReactNode;
}

/**
 * A "Grow did this" line.
 *
 * @param props.children - The sentence.
 */
export const FlowArrow: React.FC<FlowArrowProps> = ({ children }) => (
  <div className="flex items-center justify-center gap-2 py-1.5 text-[15px] font-semibold leading-tight text-primary">
    <Sparkles className="h-5 w-5 shrink-0" aria-hidden="true" />
    <span>{children}</span>
    <ArrowDown className="h-5 w-5 shrink-0" aria-hidden="true" />
  </div>
);
